import React from 'react';
import { Label } from 'legacyComponents/styled/lib';
import { SmallCard as Card } from 'legacyComponents/cards/styles';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { withNamespaces } from 'react-i18next';

export const LabelCard = withNamespaces('labels')(
  ({ cardObject, cardNo, cardColumns, t }) => {
    // TODO:
    // - Deletion mutation for Labels
    // - Add deleteIcon if canDelete
    const noMargin = (cardNo + 1) % cardColumns === 0;

    const { id, name, color } = cardObject;
    return (
      <Card noMargin={noMargin}>
        <Label id={id} backgroundColor={`#${color}`} fixed>
          {t(name)}
        </Label>
        {/* <Count>{count} open issues</Count> */}
      </Card>
    );
  },
);

// const Count = styled.p`
//   float: right;
//   margin: 3px 0px 0px;
//   font-size: 0.8125em;
//   color: ${props => props.theme.color.wfGrey500};
// `;

LabelCard.propTypes = {
  cardObject: PropTypes.object,
  cardColumns: PropTypes.number,
  cardNo: PropTypes.number,
  type: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.string,
  count: PropTypes.number,
  noMargin: PropTypes.bool,
  t: PropTypes.func,
};
